const data = [
  {
    title: 'My Photography Portfolio',
    image: '/images/projects/photography.png',
    link: 'https://photo.leodong.me',
    desc:
      'Link to site.',
  },
];

export default data;
